<template>
  <div>
    <div v-if="!error" class="flex">
      <div>Generando pdf</div>
      <div v-if="loading === true" class="px-4 py-0">
        <FacebookLoader :color="nightMode ? '#121212' : '#FFFFFF'" :size="24" />
      </div>
    </div>
    <div v-if="error">{{ error }}</div>
    <pdf-component
      v-if="this.graphs.length > 0 && enablePdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="$isMobile() ? true : false"
      :preview-modal="$isMobile() ? false : true"
      :paginate-elements-by-height="1100"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasDownloaded="hasDownloaded($event)"
      @hasPaginated="hasPaginated($event)"
      ref="html2Pdf"
    >
      <section
        v-if="reportData.report.type === 1"
        slot="pdf-content"
        class="text-xs mx-10"
      >
        <div class="firstPage relative">
          <div
            class="absolute text-black"
            style="top: 1060px; margin-left: 35px"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <section class="pdf-item">
            <img
              class="w-48 mx-auto py-6"
              :src="require(`@/assets/logoshcolor.png`)"
            />

            <div class="table grid grid-cols-2 text-center">
              <div
                class="
                  table-labels
                  col-span-2
                  py-1
                  border border-black border-collapse
                  font-bold
                "
              >
                {{ $t("report_pdf_l1") }}
              </div>
              <div class="table-left grid grid-cols-3 justify-center">
                <div
                  class="
                    labels
                    table-labels
                    grid grid-rows-4
                    col-span-1
                    border-b border-l border-r border-black
                  "
                >
                  <div class="border-b border-black">
                    {{ $t("report_pdf_location") }}
                  </div>
                  <div class="border-b border-black">
                    {{ $t("report_pdf_l2") }}
                  </div>
                  <div class="row-span-2 flex items-center m-auto">
                    {{ $t("report_pdf_l3") }}
                  </div>
                </div>
                <div
                  class="
                    table-values
                    col-span-2
                    border-r border-b border-black border-collapse
                  "
                >
                  <div class="border-b border-black">
                    {{
                      reportData.solarHub.cluster
                        ? reportData.solarHub.cluster.location
                        : ""
                    }}
                  </div>
                  <div class="border-b border-black">
                    {{ reportData.solarHub.name }}
                  </div>
                  <div class="grid grid-cols-2">
                    <div class="border-b border-r border-black">
                      {{ $t("report_pdf_l4") }}
                    </div>
                    <div class="border-b border-black">
                      {{ getProgramDate(reportData.schedule.frequency) }}
                    </div>
                  </div>
                  <div class="grid grid-cols-2">
                    <div class="border-r border-black">
                      {{ $t("report_pdf_l5") }}
                    </div>
                    <div>
                      {{ formatDate() }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="
                  table-right
                  grid grid-cols-3
                  justify-center
                  border-r border-b border-black
                  bg-white
                "
              >
                <div
                  class="
                    labels
                    table-labels
                    col-span-1
                    border-r border-b border-black
                  "
                >
                  <div>{{ $t("report_pdf_l6") }}</div>
                </div>
                <div
                  class="table-values values col-span-2 border-b border-black"
                >
                  <div>
                    {{ getSensorNames }}
                  </div>
                </div>
                <div
                  class="
                    table-values
                    col-span-3
                    font-bold
                    flex
                    items-center
                    m-auto
                  "
                >
                  {{ filename }}
                </div>
              </div>
            </div>
            <hr class="h-4" />
            <div
              v-if="
                rValues.some(
                  (item) =>
                    item.influxId === 'NO2' ||
                    item.influxId === 'SO2' ||
                    item.influxId === 'O3' ||
                    item.influxId === 'PM10' ||
                    item.influxId === 'PM2_5' ||
                    item.influxId === 'CO'
                )
              "
              class="graphics text-center"
            >
              <div class="table-labels font-bold py-1 border border-black">
                {{ $t("report_pdf_e1") }}
              </div>
              <div class="graphic-global">
                <div>
                  <PdfLineChart
                    :data="rValues"
                    :single="''"
                    class="small"
                    style="position: relative; width: 700px; height: 230px"
                  />
                </div>
                <div class="table-minmax">
                  <div class="flex flex-row justify-center text-black my-2">
                    <div class="flex flex-col">
                      <div
                        class="border-r border-b border-black text-transparent"
                      >
                        _
                      </div>
                      <div class="border-r border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-r border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                    </div>
                    <div v-for="g in rValues" :key="g.id">
                      <div
                        class="flex flex-col"
                        v-if="g.influxId !== 'CO2' && g.influxId !== 'noise'"
                      >
                        <div class="border-b border-black px-2">
                          {{ g.name }}
                        </div>
                        <div class="table-labels">{{ tableMax(g) }}</div>
                        <div>{{ tableMin(g) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                rValues.some(
                  (item) => item.influxId === 'noise' || item.influxId === 'CO2'
                )
              "
              class="two-graphics pt-1"
            >
              <div
                class="g-titles table-labels border border-black text-center"
                :style="
                  rValues.some((item) => item.influxId === 'noise') &&
                  rValues.some((item) => item.influxId === 'CO2')
                    ? 'display:grid;grid-template-columns: repeat(2, 50% 50%);'
                    : 'grid grid-cols-1'
                "
              >
                <div
                  class="border-r border-black"
                  v-if="rValues.some((item) => item.influxId === 'CO2')"
                >
                  {{$t("map_sensors_CO2")}}
                </div>
                <div v-if="rValues.some((item) => item.influxId === 'noise')">
                  {{ $t("dashboard_sensor_noise2") }}
                </div>
              </div>
              <div
                class="g-graphics"
                :style="
                  rValues.some((item) => item.influxId === 'noise') &&
                  rValues.some((item) => item.influxId === 'CO2')
                    ? 'display:grid;grid-template-columns: repeat(2, 50% 50%);'
                    : 'grid grid-cols-1;width:400px;'
                "
              >
                <PdfLineChart
                  v-if="rValues.some((item) => item.influxId === 'CO2')"
                  :data="graphs"
                  :single="'CO2'"
                  class="small"
                  style="position: relative; height: 180px"
                />

                <PdfLineChart
                  v-if="rValues.some((item) => item.influxId === 'noise')"
                  :data="graphs"
                  :single="'noise'"
                  class="small"
                  style="position: relative; height: 180px"
                />
              </div>
              <div
                class="table-minmax pt-1"
                v-if="
                  rValues.some(
                    (item) =>
                      item.influxId === 'CO2' || item.influxId === 'noise'
                  )
                "
              >
                <div class="flex flex-row justify-center text-black">
                  <div class="flex flex-col">
                    <div
                      class="border-r border-b border-black text-transparent"
                    >
                      _
                    </div>
                    <div class="border-r border-black">
                      {{ $t("report_pdf_e2") }}
                    </div>
                    <div class="border-r border-black">
                      {{ $t("report_pdf_e3") }}
                    </div>
                  </div>
                  <div v-for="g in rValues" :key="g.id">
                    <div
                      class="flex flex-col"
                      v-if="g.influxId === 'CO2' || g.influxId === 'noise'"
                    >
                      <div class="border-b border-black px-4">
                        {{
                          g.name == "noise" ? $t("map_sensors_noise") : g.name
                        }}
                      </div>
                      <div class="table-labels px-4">{{ tableMax(g) }}</div>
                      <div class="px-4">{{ tableMin(g) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="pdf-item mt-14">
            <div class="report-footer">
              <div class="table-img">
                <img
                  class="mx-auto"
                  style="width: 600px"
                  :src="
                    require('@/assets/' +
                      $t('report_pdf_image_footer') +
                      '.png')
                  "
                />
              </div>
            </div>
          </section>
        </div>
        <div class="html2pdf__page-break" />
      </section>

      <section
        v-if="reportData.report.type === 2"
        slot="pdf-content"
        class="text-xs mx-10"
      >
        <div class="firstPage relative">
          <div
            class="absolute text-black"
            style="top: 1050px; margin-left: 35px"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <section class="pdf-item mt-4">
            <img
              class="w-48 mx-auto py-6"
              :src="require(`@/assets/logoshcolor.png`)"
            />
            <div class="table grid grid-cols-2 text-center">
              <div
                class="
                  table-labels
                  col-span-2
                  py-1
                  border border-black border-collapse
                  font-bold
                "
              >
                {{ $t("report_pdf_r1") }}
              </div>
              <div class="table-left grid grid-cols-3 justify-center">
                <div
                  class="
                    labels
                    table-labels
                    grid grid-rows-4
                    col-span-1
                    border-b border-l border-r border-black
                  "
                >
                  <div class="border-b border-black">
                    {{ $t("report_pdf_location") }}
                  </div>
                  <div class="border-b border-black">
                    {{ $t("report_pdf_l2") }}
                  </div>
                  <div class="row-span-2 flex items-center m-auto">
                    {{ $t("report_pdf_l3") }}
                  </div>
                </div>
                <div
                  class="
                    table-values
                    col-span-2
                    border-r border-b border-black border-collapse
                  "
                >
                  <div class="border-b border-black">
                    {{
                      reportData.solarHub.cluster
                        ? reportData.solarHub.cluster.location
                        : ""
                    }}
                  </div>
                  <div class="border-b border-black">
                    {{ reportData.solarHub.name }}
                  </div>
                  <div class="grid grid-cols-2">
                    <div class="border-b border-r border-black">
                      {{ $t("report_pdf_l4") }}
                    </div>
                    <div class="border-b border-black">
                      {{ getProgramDate(reportData.schedule.frequency) }}
                    </div>
                  </div>
                  <div class="grid grid-cols-2">
                    <div class="border-r border-black">
                      {{ $t("report_pdf_l5") }}
                    </div>
                    <div>{{ formatDate() }}</div>
                  </div>
                </div>
              </div>
              <div
                class="
                  table-right
                  grid grid-cols-3
                  justify-center
                  border-r border-b border-black
                  bg-white
                "
              >
                <div
                  class="
                    labels
                    table-labels
                    col-span-1
                    border-r border-b border-black
                  "
                >
                  <div>{{ $t("report_pdf_l6") }}</div>
                </div>
                <div
                  class="table-values values col-span-2 border-b border-black"
                >
                  <div class="col-span-2">{{ getSensorNames }}</div>
                </div>
                <div
                  class="
                    table-values
                    col-span-3
                    row-span-3
                    font-bold
                    flex
                    items-center
                    m-auto
                  "
                >
                  {{ filename }}
                </div>
              </div>
            </div>
            <hr class="h-4" />
          </section>
          <section class="pdf-item mt-14">
            <div class="graphics text-center" style="padding-bottom: 24px">
              <div class="table-labels font-bold py-1 border border-black">
                {{ $t("report_pdf_r1_airq") }}
              </div>
              <div class="graphic-global">
                <div>
                  <PdfLineChart
                    :data="graphs"
                    :single="'AQI'"
                    class="small"
                    style="position: relative; width: 700px; height: 250px"
                  />
                </div>
              </div>
            </div>
            <img
              :src="require('@/assets/' + $t('report_pdf_r1_link_aq') + '.png')"
              style="width: 700px; height: 517px"
            />
          </section>
        </div>
        <div
          v-if="
            !(
              !rValues.some((item) => item.influxId == 'NO2') &&
              !rValues.some((item) => item.influxId == 'SO2') &&
              !rValues.some((item) => item.influxId == 'O3') &&
              !rValues.some((item) => item.influxId == 'PM10') &&
              !rValues.some((item) => item.influxId == 'PM2_5')
            )
          "
          class="html2pdf__page-break"
        />

        <section
          class="pdf-item relative"
          :style="isSafari ? '' : 'margin-top:30px;'"
        >
          <div
            v-if="
              !(
                !rValues.some((item) => item.influxId == 'NO2') &&
                !rValues.some((item) => item.influxId == 'SO2') &&
                !rValues.some((item) => item.influxId == 'O3') &&
                !rValues.some((item) => item.influxId == 'PM10') &&
                !rValues.some((item) => item.influxId == 'PM2_5')
              )
            "
            class="absolute text-black"
            style="margin-left: 35px"
            :style="isSafari ? 'margin-top:1010px;' : 'margin-top:1030px;'"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              rValues.some(
                (item) =>
                  item.influxId === 'NO2' ||
                  item.influxId === 'SO2' ||
                  item.influxId === 'O3' ||
                  item.influxId === 'PM10' ||
                  item.influxId === 'PM2_5' ||
                  item.influxId === 'CO'
              )
            "
            class="graphics text-center"
            style="padding-bottom: 24px"
          >
            <div class="table-labels font-bold py-1 border border-black">
              {{ $t("report_pdf_e1") }}
            </div>
            <div class="graphic-global">
              <div>
                <PdfLineChart
                  :data="rValues"
                  :single="''"
                  class="small"
                  style="position: relative; width: 700px; height: 250px"
                />
              </div>
            </div>
          </div>
        </section>

        <!-- NO2 SECTION -->
        <section class="pdf-item mt-14">
          <div v-if="rValues.some((item) => item.influxId === 'NO2')">
            <div
              class="
                table-labels
                font-bold
                py-1
                border border-black
                mb-2
                text-center
              "
            >
              NO2
            </div>
            <div class="r2-graph grid grid-cols-5">
              <div class="col-span-3 mt-2">
                <PdfLineChart
                  :data="graphs"
                  :single="'NO2'"
                  :lines="[
                    { name: $t('report_pdf_limit_annual'), value: 40 },
                    { name: $t('report_pdf_limit_hourly'), value: 200 },
                  ]"
                  class="small"
                  style="position: relative; width: 100%; height: 260px"
                />
              </div>
              <div class="col-span-2 flex flex-col">
                <div class="pie-chart mt-6">
                  <PdfPieChart
                    :data="graphs"
                    :single="'NO2'"
                    :hourAverage="200"
                    class="small col-span-1 mx-auto block"
                    style="position: relative; width: 70%; height: 140px"
                  />
                </div>
                <div class="table-minmax text-center">
                  <div v-for="t in rValues" :key="t.id">
                    <div class="py-4" v-if="t.influxId === 'NO2'">
                      {{ $t("report_pdf_r1_annual") }}
                      {{
                        tableMax(t) > 40
                          ? $t("report_pdf_r1_answer_yes")
                          : $t("report_pdf_r1_answer_no")
                      }}
                    </div>
                  </div>

                  <div class="table-first flex flex-row justify-center">
                    <div class="table-labels border border-black">
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                      <div class="px-1">{{ $t("report_pdf_e4") }}</div>
                    </div>
                    <div v-for="t in rValues" :key="t.id">
                      <div class="table-values" v-if="t.influxId === 'NO2'">
                        <div
                          class="border-t border-r border-b border-black px-2"
                        >
                          {{ tableMax(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableMin(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableAvg(t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="legend mt-10">
              <div class="text-left text-xs">
                <p>{{ $t("report_pdf_r1_no2_p1") }}</p>
                <br />
                <p>{{ $t("report_pdf_r1_no2_p2") }}</p>
              </div>
            </div>
          </div>
        </section>
        <div
          v-if="
            rValues.some((item) => item.influxId == 'NO2') &&
            (rValues.some((item) => item.influxId == 'SO2') ||
              rValues.some((item) => item.influxId == 'O3'))
          "
          class="html2pdf__page-break"
        />
        <!-- SO2 SECTION -->
        <section
          class="pdf-item relative"
          :class="{ 'mt-10': !isSafari, '': isSafari }"
        >
          <div
            v-if="
              (rValues.some((item) => item.influxId == 'NO2') &&
                rValues.some((item) => item.influxId == 'O3') &&
                rValues.some((item) => item.influxId == 'SO2')) ||
              (rValues.some((item) => item.influxId == 'NO2') &&
                !rValues.some((item) => item.influxId == 'O3') &&
                rValues.some((item) => item.influxId == 'SO2'))
            "
            class="absolute"
            style="top: 1020px; margin-left: 35px"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="rValues.some((item) => item.influxId === 'SO2')">
            <div
              class="
                table-labels
                font-bold
                py-1
                border border-black
                mb-2
                text-center
              "
            >
              SO2
            </div>
            <div class="r2-graph grid grid-cols-5">
              <div class="col-span-3 mt-2">
                <PdfLineChart
                  :data="graphs"
                  :single="'SO2'"
                  :lines="[
                    { name: $t('report_pdf_limit_daily'), value: 125 },
                    { name: $t('report_pdf_limit_hourly'), value: 350 },
                  ]"
                  class="small"
                  style="position: relative; width: 100%; height: 260px"
                />
              </div>
              <div class="col-span-2 flex flex-col mt-6">
                <div class="pie-chart">
                  <PdfPieChart
                    :data="graphs"
                    :single="'SO2'"
                    :hourAverage="350"
                    class="small col-span-1 mx-auto block"
                    style="position: relative; width: 70%; height: 140px"
                  />
                </div>
                <div class="table-minmax text-center">
                  <div v-for="t in rValues" :key="t.id">
                    <div class="py-4" v-if="t.influxId === 'SO2'">
                      {{ $t("report_pdf_r1_daily") }}
                      {{
                        tableMax(t) > 125
                          ? $t("report_pdf_r1_answer_yes")
                          : $t("report_pdf_r1_answer_no")
                      }}
                    </div>
                  </div>

                  <div class="table-first flex flex-row justify-center">
                    <div class="table-labels border border-black">
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                      <div class="px-1">{{ $t("report_pdf_e4") }}</div>
                    </div>
                    <div v-for="t in rValues" :key="t.id">
                      <div class="table-values" v-if="t.influxId === 'SO2'">
                        <div
                          class="border-t border-r border-b border-black px-2"
                        >
                          {{ tableMax(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableMin(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableAvg(t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="legend mt-8">
              <div class="text-left text-xs">
                <p class="mb-2">{{ $t("report_pdf_r1_so2_p1") }}</p>
                <p>{{ $t("report_pdf_r1_so2_p2") }}</p>
              </div>
            </div>
          </div>
        </section>
        <div
          v-if="
            (!rValues.some((item) => item.influxId == 'O3') &&
              rValues.some((item) => item.influxId == 'S02')) ||
            (!rValues.some((item) => item.influxId == 'NO2') &&
              rValues.some((item) => item.influxId == 'O3') &&
              rValues.some((item) => item.influxId == 'SO2'))
          "
          class="html2pdf__page-break"
        />
        <!-- O3 SECTION -->
        <section class="pdf-item mt-10 relative">
          <div
            v-if="
              (rValues.some((item) => item.influxId === 'NO2') &&
                rValues.some((item) => item.influxId === 'O3') &&
                !rValues.some((item) => item.influxId === 'SO2')) ||
              (!rValues.some((item) => item.influxId === 'NO2') &&
                rValues.some((item) => item.influxId === 'O3') &&
                rValues.some((item) => item.influxId === 'SO2'))
            "
            class="absolute"
            style="top: 990px; margin-left: 35px"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="rValues.some((item) => item.influxId === 'O3')">
            <div
              class="
                table-labels
                font-bold
                py-1
                border border-black
                mb-2
                text-center
              "
            >
              O3
            </div>
            <div class="r2-graph grid grid-cols-5">
              <div class="col-span-3 mt-2">
                <PdfLineChart
                  :data="graphs"
                  :single="'O3'"
                  :lines="[
                    { name: '8' + $t('report_pdf_limit_hours'), value: 120 },
                    {
                      name: $t('report_pdf_limit_hourly') + ' (LLI*)',
                      value: 180,
                    },
                    {
                      name: $t('report_pdf_limit_hourly') + ' (LLA*)',
                      value: 240,
                    },
                  ]"
                  class="small"
                  style="position: relative; width: 100%; height: 260px"
                />
              </div>
              <div class="col-span-2 flex flex-col mt-6">
                <div class="pie-chart">
                  <PdfPieChart
                    :data="graphs"
                    :single="'O3'"
                    :hourAverage="120"
                    class="small col-span-1 mx-auto block"
                    style="position: relative; width: 70%; height: 140px"
                  />
                </div>
                <div class="table-minmax text-center">
                  <div class="table-first flex flex-row justify-center">
                    <div class="table-labels border border-black">
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                      <div class="px-1">{{ $t("report_pdf_e4") }}</div>
                    </div>
                    <div v-for="t in rValues" :key="t.id">
                      <div class="table-values" v-if="t.influxId === 'O3'">
                        <div
                          class="border-t border-r border-b border-black px-2"
                        >
                          {{ tableMax(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableMin(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableAvg(t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="legend mt-8">
              <div v-for="t in rValues" :key="t.id">
                <div
                  class="flex flex-row font-bold justify-between my-4"
                  v-if="t.influxId === 'O3'"
                >
                  <div>
                    {{ $t("report_pdf_r1_o3_t1") }}
                    {{
                      tableMax(t) > 180
                        ? $t("report_pdf_r1_answer_yes")
                        : $t("report_pdf_r1_answer_no")
                    }}.
                  </div>
                  <div>
                    {{ $t("report_pdf_r1_o3_t2") }}
                    {{
                      tableMax(t) > 240
                        ? $t("report_pdf_r1_answer_yes")
                        : $t("report_pdf_r1_answer_no")
                    }}
                  </div>
                </div>
              </div>

              <div class="text-left text-xs">
                <p class="mb-2">{{ $t("report_pdf_r1_o3_p1") }}</p>
                <p>{{ $t("report_pdf_r1_o3_p2") }}</p>
              </div>
            </div>
          </div>
        </section>
        <div
          v-if="
            rValues.some((item) => item.influxId == 'PM10') ||
            rValues.some((item) => item.influxId == 'PM2_5')
          "
          class="html2pdf__page-break"
        />

        <!-- PM10 and PM2.5 SECTION -->
        <section
          class="pdf-item relative"
          :class="{ 'mt-16': !isSafari, 'mt-6': isSafari }"
        >
          <div
            v-if="
              rValues.some((item) => item.influxId == 'PM10') ||
              rValues.some((item) => item.influxId == 'PM2_5')
            "
            class="absolute"
            style="top: 990px; margin-left: 35px"
          >
            <div class="report-footer">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              rValues.some(
                (item) => item.influxId === 'PM10' || item.influxId === 'PM2_5'
              )
            "
          >
            <div
              class="
                table-labels
                font-bold
                py-1
                border border-black
                mb-2
                text-center
              "
            >
              {{
                rValues.some((item) => item.influxId === "PM10") &&
                rValues.some((item) => item.influxId === "PM2_5")
                  ? $t("report_pdf_r1_pm_title")
                  : rValues.some((item) => item.influxId === "PM10")
                  ? "PM10"
                  : "PM2.5"
              }}
            </div>
            <div
              v-if="rValues.some((item) => item.influxId === 'PM10')"
              class="r2-graph grid grid-cols-5"
            >
              <div class="col-span-3 mt-2">
                <PdfLineChart
                  :data="graphs"
                  :single="'PM10'"
                  :lines="[
                    { name: $t('report_pdf_limit_annual'), value: 40 },
                    { name: $t('report_pdf_limit_daily'), value: 7 },
                  ]"
                  class="small"
                  style="position: relative; width: 100%; height: 230px"
                />
              </div>
              <div class="col-span-2 flex flex-col mt-6">
                <div class="pie-chart">
                  <PdfPieChart
                    :data="graphs"
                    :single="'PM10'"
                    :hourAverage="50"
                    class="small col-span-1 mx-auto block"
                    style="position: relative; width: 70%; height: 140px"
                  />
                </div>
                <div class="table-minmax text-center">
                  <div v-for="t in rValues" :key="t.id">
                    <div class="py-4" v-if="t.influxId === 'PM10'">
                      {{ $t("report_pdf_r1_annual") }}
                      {{
                        tableMax(t) > 40
                          ? $t("report_pdf_r1_answer_yes")
                          : $t("report_pdf_r1_answer_no")
                      }}
                    </div>
                  </div>

                  <div class="table-first flex flex-row justify-center">
                    <div class="table-labels border border-black">
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                      <div class="px-1">{{ $t("report_pdf_e4") }}</div>
                    </div>
                    <div v-for="t in rValues" :key="t.id">
                      <div class="table-values" v-if="t.influxId === 'PM10'">
                        <div
                          class="border-t border-r border-b border-black px-2"
                        >
                          {{ tableMax(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableMin(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableAvg(t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="rValues.some((item) => item.influxId === 'PM2_5')"
              class="r2-graph grid grid-cols-5 pt-6"
            >
              <div class="col-span-3">
                <PdfLineChart
                  :data="graphs"
                  :single="'PM2_5'"
                  :lines="[{ name: $t('report_pdf_limit_annual'), value: 25 }]"
                  class="small"
                  style="position: relative; width: 100%; height: 230px"
                />
              </div>
              <div class="col-span-2 flex flex-col">
                <div class="pie-chart" style="height: 140px">
                  <PdfPieChart
                    :data="graphs"
                    :single="'PM2_5'"
                    :hourAverage="25"
                    class="small col-span-1 mx-auto block"
                    style="position: relative; width: 70%; height: 140px"
                  />
                </div>
                <div class="table-minmax text-center">
                  <div v-for="t in rValues" :key="t.id">
                    <div class="py-4" v-if="t.influxId === 'PM2_5'">
                      {{ $t("report_pdf_r1_annual") }}
                      {{
                        tableMax(t) > 25
                          ? $t("report_pdf_r1_answer_yes")
                          : $t("report_pdf_r1_answer_no")
                      }}
                    </div>
                  </div>

                  <div class="table-first flex flex-row justify-center">
                    <div class="table-labels border border-black">
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e2") }}
                      </div>
                      <div class="border-b border-black">
                        {{ $t("report_pdf_e3") }}
                      </div>
                      <div class="px-1">{{ $t("report_pdf_e4") }}</div>
                    </div>
                    <div v-for="t in rValues" :key="t.id">
                      <div class="table-values" v-if="t.influxId === 'PM2_5'">
                        <div
                          class="border-t border-r border-b border-black px-2"
                        >
                          {{ tableMax(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableMin(t) }}
                        </div>
                        <div class="border-b border-r border-black px-2">
                          {{ tableAvg(t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="legend mt-6">
              <div class="text-left text-xs">
                <p>{{ $t("report_pdf_r1_pm_p1") }}</p>
                <br />
                <p>{{ $t("report_pdf_r1_pm_p2") }}</p>
                <br />
                <p>{{ $t("report_pdf_r1_pm_p3") }}</p>
              </div>
            </div>
          </div>
        </section>
        <div
          v-if="
            rValues.some((item) => item.influxId == 'PM10') ||
            rValues.some((item) => item.influxId == 'PM2_5')
          "
          class="html2pdf__page-break"
        />
        <div
          v-if="
            !rValues.some((item) => item.influxId == 'PM10') &&
            !rValues.some((item) => item.influxId == 'PM2_5')
          "
          class="html2pdf__page-break"
        />

        <!-- TWO GRAPHICS SECTION -->
        <div class="relative">
          <section
            class="pdf-item"
            :class="{ 'mt-10': !isSafari, 'mt-0': isSafari }"
          >
            <div
              v-if="!isSafari"
              class="absolute"
              style="top: 1020px; margin-left: 35px"
            >
              <div class="report-footer">
                <div class="report-footer-text">
                  <div
                    class="
                      grid grid-rows-2
                      justify-center
                      items-center
                      text-center
                    "
                  >
                    <div>
                      Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                      EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                    </div>
                    <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                rValues.some(
                  (item) => item.influxId === 'noise' || item.influxId === 'CO2'
                )
              "
              class="two-graphics pt-2"
            >
              <div
                class="g-titles table-labels border border-black text-center"
                :style="
                  rValues.some((item) => item.influxId === 'noise') &&
                  rValues.some((item) => item.influxId === 'CO2')
                    ? 'display:grid;grid-template-columns: repeat(2, 50% 50%);'
                    : 'grid grid-cols-1'
                "
              >
                <div
                  class="border-r border-black"
                  v-if="rValues.some((item) => item.influxId === 'CO2')"
                >
                  {{ $t("map_sensors_CO2") }}
                </div>
                <div v-if="rValues.some((item) => item.influxId === 'noise')">
                  {{ $t("map_sensors_noise") }}
                </div>
              </div>
              <div
                class="g-graphics"
                :style="
                  rValues.some((item) => item.influxId === 'noise') &&
                  rValues.some((item) => item.influxId === 'CO2')
                    ? 'display:grid;grid-template-columns: repeat(2, 50% 50%);'
                    : 'grid grid-cols-1;width:400px;'
                "
              >
                <PdfLineChart
                  v-if="rValues.some((item) => item.influxId === 'CO2')"
                  :data="graphs"
                  :single="'CO2'"
                  class="small"
                  style="position: relative; height: 200px"
                />

                <PdfLineChart
                  v-if="rValues.some((item) => item.influxId === 'noise')"
                  :data="graphs"
                  :single="'noise'"
                  class="small"
                  style="position: relative; height: 200px"
                />
              </div>
              <div
                class="table-minmax mt-6"
                v-if="
                  rValues.some(
                    (item) =>
                      item.influxId === 'CO2' || item.influxId === 'noise'
                  )
                "
              >
                <div
                  class="flex flex-row justify-center text-black text-center"
                >
                  <div class="flex flex-col">
                    <div
                      class="
                        border-r border-b border-black
                        px-4
                        text-transparent
                      "
                    >
                      _
                    </div>
                    <div class="border-r border-black px-4">
                      {{ $t("report_pdf_e2") }}
                    </div>
                    <div class="border-r border-black px-4">
                      {{ $t("report_pdf_e3") }}
                    </div>
                  </div>
                  <div v-for="g in rValues" :key="g.id">
                    <div
                      class="flex flex-col"
                      v-if="g.influxId === 'CO2' || g.influxId === 'noise'"
                    >
                      <div class="border-b border-black px-4">
                        {{
                          g.name == "noise" ? $t("map_sensors_noise") : g.name
                        }}
                      </div>
                      <div class="table-labels px-4">{{ tableMax(g) }}</div>
                      <div class="px-4">{{ tableMin(g) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="report-footer">
              <div class="table-img">
                <img
                  class="mx-auto"
                  style="width: 600px; height: 280px"
                  :src="
                    require('@/assets/' +
                      $t('report_pdf_image_footer') +
                      '.png')
                  "
                />
              </div>
            </div>
            <div v-if="!isSafari" class="html2pdf__page-break" />
            <div v-if="isSafari" class="report-footer" style="height: 200px">
              <div class="report-footer-text">
                <div
                  class="
                    grid grid-rows-2
                    justify-center
                    items-center
                    text-center
                  "
                >
                  <div>
                    Siarq Technologies SL - Avenida Diagonal 523 5ta planta –
                    EDIFICIO ATALAYA – 08029 BARCELONA -ESPAÑA
                  </div>
                  <div>t+34-935533913 urbanbrain@siarq.com www.siarq.com</div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </pdf-component>
  </div>
</template>
<script>
/**
 * Vista de Reporte pdf programado.
 * --------------------------------------------
 *
 * Vista de reporte donde a partir de una petición, recibimos y rellenamos las gráficas y creamos la estructura para generar el pdf.
 * Los componentes que se usan son: El componente para mostrar el pdf, las gráficas donut y de línea y el loader antes de mostrarse el pdf.
 *
 */
import VueHtml2pdf from "vue-html2pdf";
import PdfLineChart from "../components/charts/PdfLineChart.vue";
import PdfPieChart from "../components/charts/PdfPieChart.vue";
import { getListSolarHubs } from "@/utils/SolarHubService.js";
import { FacebookLoader } from "vue-spinners-css";
import { getReportByUuid } from "@/utils/ReportService.js";

import { mapState } from "vuex";
import PdfComponent from "../components/pdftypes/PdfComponent.vue";

export default {
  components: {
    VueHtml2pdf,
    PdfLineChart,
    PdfPieChart,
    PdfComponent,
    FacebookLoader,
  },
  name: "HtmlToPdfView",
  props: ["nightMode", "selectedCluster", "selectedHub"],
  data() {
    return {
      fValues: [{ name: "All" }],
      graphs: {},
      enablePdf: false,
      sensorUnits: 0,
      idsPdf: {},
      reportData: {},
      error: "",
      loading: false,
      contador: sessionStorage.getItem("contador"),
      interval: null,
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      blobPdf: null,
    };
  },
    /**
   * Método para obtener un contador de sessionStorage y saber cuando puede comenzar a cargar los datos para pintar las gráficas. 
   * Obtenemos los datos a través de una petición que envía 2 parametros de la url(uuid y id del reporte)
   * emitimos el pdfmode para limpiar el navbar y subnavbar de la vista
   */
  async beforeMount() {
    sessionStorage.setItem("contador", 0);
    this.$emit("pdfmode", true);

    try {
      this.reportData = await getReportByUuid(
        this.$route.params.id,
        this.$route.params.id2
      );
    } catch (error) {
      this.error = "Link invalido";
    }

    this.graphs = JSON.parse(this.reportData.report.jsonData);

    this.graphs.forEach((element) => {
      if (
        element.name !== "I_BATT_000" &&
        element.name !== "PWM_Led_000" &&
        element.name !== "SoC_000" &&
        element.influxId !== "T" &&
        element.influxId !== "RH"
      ) {
        this.fValues.push({ name: element.name });
      }
    });

    this.enablePdf = true;
  },
  /**
   * Método para crear un intérvalo de tiempo antes de mostrar el pdf generado(Si no hay un intérvalo de tiempo, el pdf se puede generar antes y provoca que no de tiempo
   * a que se dibujen las gráficas)
   */
  async mounted() {
    this.interval = setInterval(() => this.getCounter(), 2000);
    this.loading = true;
  },
  methods: {
    test() {
      const $body = document.querySelector("body");
      let scrollPosition = 0;
      $body.style.removeProperty("overflow");
      $body.style.removeProperty("position");
      $body.style.removeProperty("top");
      $body.style.removeProperty("width");
      window.scrollTo(0, scrollPosition);
    },
  /**
   * Método para después de la carga del pdf
   */
    async hasDownloaded(event) {
      this.blobPdf = URL.createObjectURL(event);
    },

  /**
   * Método para contar cada gráfico que ha sido dibujado antes de ponerlo dentro del pdf
   */
    getCounter() {
      if (
        parseInt(sessionStorage.getItem("contador")) === this.graphicLength() &&
        this.graphicLength() !== 0
      ) {
        clearInterval(this.interval);
        let p = setTimeout(() => this.generateReport(), 1000);
      }
    },
  /**
   * Método para obtener los datos de los sensores para dibujar las gráficas.
   */
    async loadGraphs() {
      const data = await getListSolarHubs(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id
      );
      this.graphs = await data[0].sensors;

      this.graphs.forEach((element) => {
        if (
          element.name !== "I_BATT_000" &&
          element.name !== "PWM_Led_000" &&
          element.name !== "SoC_000" &&
          element.influxId !== "T" &&
          element.influxId !== "RH"
        ) {
          this.fValues.push({ name: element.name });
        }
      });
    },
  /**
   * Método para generar el pdf
   */
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf();
      this.loading = false;
      sessionStorage.removeItem("contador");
    },
  /**
   * Método para filtrar los sensores recibidos por la petición a partir de los datos de la url.
   */
    filterBySelect() {
      var arrayFil = [];
      if (this.graphs.filter((e) => e.name === "All").length > 0) {
        var fValuesFilt = [];
        fValuesFilt = this.fValues.filter((e) => e.name !== "All");
        this.graphs.forEach((element) => {
          fValuesFilt.forEach((el) => {
            if (el.name === element.name && element.type === "line") {
              arrayFil.push(element);
            }
          });
        });
      } else {
        this.graphs.forEach((element) => {
          if (element.type === "line") {
            arrayFil.push(element);
          }
        });
      }
      this.sensorUnits = arrayFil.length;
      return arrayFil;
    },
  /**
   * Método para obtener el array de valores de un sensor
   */
    getArrayValues(s) {
      let arr = [];
      s.sensor_data.forEach((va) => {
        arr.push(va[1]);
      });
      return arr;
    },
  /**
   * Método que calcula la media de los valores de los sensores
   */
    tableAvg(s) {
      var total = 0;
      s.sensor_data.forEach((va) => {
        total += va[1];
      });
      return Math.round((total / s.sensor_data.length) * 100) / 100;
    },
  /**
   * Método que calcula el valor más alto de los valores de los sensores
   */
    tableMax(s) {
      var max =
        Math.round(
          (Math.max(...this.getArrayValues(s)) + Number.EPSILON) * 100
        ) / 100;
      return max;
    },
  /**
   * Método que calcula el valor más bajo de los valores de los sensores
   */
    tableMin(s) {
      var min =
        Math.round(
          (Math.min(...this.getArrayValues(s)) + Number.EPSILON) * 100
        ) / 100;
      return min;
    },
  /**
   * Método para dar formato a la fecha del reporte.
   */
    formatDate() {
      let date = new Date(this.reportData.report.creationDate);

      return date.toLocaleDateString('es-ES');
    },
  /**
   * Método que a partir de la frecuéncia que se le pase por parámetro devuelve una fecha.
   * @param frequency
   * @returns fecha formateada.
   */
    getProgramDate(frequency) {
      let programDate = new Date();
      let creationDate = new Date(this.reportData.report.creationDate);
      frequency === "weekly"
        ? programDate.setDate(creationDate.getDate() - 7)
        : programDate.setDate(creationDate.getDate() - 1);
      return programDate.toLocaleDateString('es-ES');
    },
  /**
   * Método para devolver la cnatidad de sensores que tienen que dibujarse en el gráfico de pollution, se filtran los que sí tienen que ir dibujados.
   */
    graphicLength() {
      let graphicCounter = 0;
      let pollutionCounter = 0;
      let pollutionList = ["NO2", "SO2", "O3", "PM10", "PM2_5"];
      if (this.rValues.length !== 0 && this.reportData.report.type == 2) {
        let names = [];
        names = this.rValues.map((r) => {
          return r.influxId;
        });
        names.some((p) => pollutionList.includes(p)) ? pollutionCounter++ : 0;
        graphicCounter = this.rValues.length + pollutionCounter;
      } else {
        let counterL1 = 0;
        let names = [];
        names = this.rValues.map((r) => {
          return r.influxId;
        });
        names.some((p) => pollutionList.includes(p)) ? counterL1++ : 0;
        names.includes("CO2") ? counterL1++ : 0;
        names.includes("noise") ? counterL1++ : 0;

        graphicCounter = counterL1;
      }

      return graphicCounter;
    },
  },
  computed: {
    ...mapState("reports", ["reportState"]),
    ...mapState("clusters", ["currentCluster"]),
  /**
   * El nombre del archivo
   */
    filename() {
      return `SOLARHUB-${new Date()
        .toLocaleDateString('es-ES')
        .split("/")
        .reverse()
        .join("")}-${this.reportData.report.id}`;
    },
    
  /**
   * Retorna el nombre de los sensores separados por comas.
   */
    getSensorNames() {
      var names = [];
      this.graphs.forEach((element) => {
        names.push(element.name);
      });
      return names.join(", ");
    },
    
  /**
   * Los valores filtrados
   */
    rValues() {
      return this.filterBySelect();
    },
  },
};
</script>

<style>
.cluster-gray {
  background-color: #68696d;
}
.cluster-gray-border {
  border-color: #cccccc;
}
.report-footer {
  margin-left: 30px;
}
.reports-select-dark {
  background-color: #fff;
}
.reports {
  background-color: #1a1a1a;
  color: white;
}
::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  background-color: white;
  cursor: pointer;
  border-radius: 0%;
}

.table-pdf td,
.table-pdf th {
  border: 1px solid black;
}

.table-pdf td {
  padding-left: 10px;
}

.multiselect__placeholder {
  white-space: nowrap !important;
}
.multiselect {
  width: auto !important;
}
.table-labels {
  background-color: #dbdbdb;
  color: black;
}
.table-values {
  background-color: white;
  color: black;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

#app .vue-html2pdf .pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 0;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;
}

html,
body {
  position: fixed;
}

html,
body {
  position: relative;
  overflow: hidden;
}

body {
  position: fixed;
  overflow: hidden;
}

body {
  position: fixed;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
</style>
